import script from "./CallControl.vue?vue&type=script&setup=true&lang=js"
export * from "./CallControl.vue?vue&type=script&setup=true&lang=js"

import "./CallControl.vue?vue&type=style&index=0&id=4ab6135f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab6135f"]])

export default __exports__